const app = {
  home_page_title: "Coding Step By Step",
};

export default app;
